import { InjectionToken } from '@angular/core';

import { ResolvedThemeOptions, ThemeOptions } from './theme.types';

export const DEFAULT_THEME_OPTIONS: ResolvedThemeOptions = {
  defaultPreference: 'light',
  storageKey: 'kros.theme',
  persist: true,
  syncWithSystem: true,
  attributeName: 'data-theme',
  useColorScheme: true,
  onThemeChange: null,
};

export function resolveThemeOptions(options: ThemeOptions = {}): ResolvedThemeOptions {
  return {
    defaultPreference: options.defaultPreference ?? DEFAULT_THEME_OPTIONS.defaultPreference,
    storageKey: options.storageKey ?? DEFAULT_THEME_OPTIONS.storageKey,
    persist: options.persist ?? DEFAULT_THEME_OPTIONS.persist,
    syncWithSystem: options.syncWithSystem ?? DEFAULT_THEME_OPTIONS.syncWithSystem,
    attributeName: options.attributeName ?? DEFAULT_THEME_OPTIONS.attributeName,
    useColorScheme: options.useColorScheme ?? DEFAULT_THEME_OPTIONS.useColorScheme,
    onThemeChange: options.onThemeChange ?? DEFAULT_THEME_OPTIONS.onThemeChange,
  };
}

export const THEME_OPTIONS = new InjectionToken<ResolvedThemeOptions>('THEME_OPTIONS', {
  factory: (): ResolvedThemeOptions => DEFAULT_THEME_OPTIONS,
});
